namespace('compass.group');

compass.require('compass.group.ModifyRoomWidget');
compass.require('compass.group.RoomTypeArriveDepartWidget');
compass.require('compass.util.validate');
compass.requireLib('compass.group.NamesHelper');

compass.group.RoomManageWidget = compass.defineWidget(function RoomManageWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom.getContext(me);

	var _settings = options;
	var _roomEditable = _settings.blockEditable;
	var _translate = true;

	var _isCharging = false;
	if (_settings.blockData.chargingInfo) {
		_isCharging = _settings.blockData.chargingInfo.has_charging || false;
	}
	
	if (_roomEditable && _settings.assignedRoom ){
		_roomEditable = _settings.assignedRoom.reservationBase.nameEditable;
	}

	var _spinner;
	var isAssignedFormChanged = false;

	var groupMemberList = [{addMember: true}];
	groupMemberList = groupMemberList.concat(_settings.memberList);
	var useGroupMemberList = (_settings.groupInfo.nameAssignmentEnabled && _settings.memberList.length > 0);
	var groupMemberSelection = {};

	var _removeErrors = function(form){
		form.find('.invalid').removeClass('invalid');
		form.find('.parsley-error-list').remove();
	};

	var _revertForm = function(room) {
		var selectorValueArray = [
			{ selector: 'input.firstName', value: room.individualBase.first_name },
			{ selector: 'input.lastName', value: room.individualBase.last_name },
			{ selector: 'input.email', value: room.individualBase.email },
			{ selector: '.roomTypes', value: room.roomType }
		];
		_.each(selectorValueArray, function(element) {
			assignedRoomForm.find(element.selector).val(element.value);
		});

		_removeErrors(assignedRoomForm);

		var rtArriveDepartContainer = assignedRoomForm.find('.roomTypeArriveDepartContainer');
		rtArriveDepartContainer.empty();
		_drawRoomTypeArriveDepart(rtArriveDepartContainer);
	};

	me.update = function(updateData) {
		var ajaxSuccess = updateData.data.success;

		var updateMethods = {
			discardChanges:function(roomData){
				var assignedRoomForm = me.find('.assignedRoomForm');
				_revertForm(_settings.assignedRoom);
				me.hideLoadingOverlay(assignedRoomForm);
			},
			room:function(roomData){
				var assignRoomForm = me.find('.assignedRoomForm');
				me.hideLoadingOverlay(assignRoomForm);
				if(ajaxSuccess) {
					assignRoomForm.toggleClass('hasError red_border', false);
					_settings.assignedRoom.individualBase = roomData.individualBase;
					_settings.assignedRoom.reservationBase = roomData.reservationBase;
					_settings.assignedRoom.roomTypeBase = roomData.roomTypeBase;
					var newForm = _drawAssignedRoomForm();
					assignRoomForm.after(newForm);
					assignRoomForm.remove();
					newForm.find('.firstName').focus();
				}
				else {
					var newForm = _drawAssignedRoomForm();
					assignRoomForm.after(newForm);
					assignRoomForm.remove();
					newForm.toggleClass('hasError red_border', true);
				}
			},
			roommates: function(roommateData) {
				if (ajaxSuccess) {
					_settings.assignedRoom.roommates = _.map(updateData.data.roommates, function(roommate) {
						return { individualBase: roommate, share_id: roommate.share_id };
					});
					me.find('.roommates').empty().append(_drawRoommates());
				} else {
					compass.loading.stop();
					var button = $('.roommatesForm').find('.roommatesSubmitButton.button');
					button.removeClass('disabled');
					button.append("Add Roommates");
				}
			},
			payment: function() {
				if (ajaxSuccess) {
					_settings.assignedRoom.currentPayment = {
						cc: updateData.data.payment.assignedRoomBase.currentPayment.cc,
						name_on_card: updateData.data.payment.assignedRoomBase.currentPayment.name_on_card,
						payment_id: updateData.data.payment.assignedRoomBase.currentPayment.payment_id,
						payMethodBase: {
							name: updateData.data.payment.assignedRoomBase.currentPayment.payMethodBase.name,
							code: updateData.data.payment.assignedRoomBase.currentPayment.payMethodBase.code,
							is_credit_card: updateData.data.payment.assignedRoomBase.currentPayment.payMethodBase.is_credit_card
						}
					};
					me.find('.paymentGuarantee').empty().append(_drawPayment());
				} else {
					compass.loading.stop();
					var button = $('.paymentForm').find('.paymentSubmitButton.button');
					button.removeClass('disabled');
					button.append("Apply Payment");
				}
			},
			requests: function() {
				if (ajaxSuccess) {
					_settings.requestsInfo = updateData.data.requests;
					var roomRequests = me.find('.roomRequests');
					roomRequests.removeClass('fa-regular').addClass('fa-solid');
				} else {
					compass.loading.stop();
					var button = $('.requestsForm').find('.requestsSubmitButton.button');
					button.removeClass('disabled');
					button.append("Save Requests");
				}
			},
			frequentGuestNumber: function() {
				_settings.assignedRoom.frequentGuestNumber = updateData.data.frequentGuestNumber;
			}
		};

		if(updateData.housing_id === _settings.assignedRoom.reservationBase.housing_id) {
			_.each(updateData.data, function(data, key) {
				if(updateMethods[key]) {
					updateMethods[key](data);
				}
			});
		}
	};

	var uniqueId = Math.random();
	var _modifyRoomId = compass.generateId();
	var unassignedRoomForm;
	var assignedRoomForm;
	var button;
	var roomTypes = _settings.roomTypes;
	var _parsleyError = false;
	var _occupancy = 0;
	var _labels = _settings.labels;

	var _roomTypeArriveDepartWidget;

	var _drawRoomForms = function() {
		if (_settings.assignedRoom) {
			return _drawAssignedRoomForm();
		} else {
			return _drawUnassignedRoomForm();
		}
	};

	var _drawRoommates = function() {
		if ((_settings.assignedRoom.roomTypeBase.occupancy - 1) === 0) {
			return;
		}

		if(_settings.assignedRoom.roomTypeBase.occupancy < _occupancy) {
			_settings.assignedRoom.roommates.length = 0;
		} else {
			_occupancy = _settings.assignedRoom.roomTypeBase.occupancy;
		}

		var roommatesLink = _getNumberOfRoommates() + "/" + (_settings.assignedRoom.roomTypeBase.occupancy - 1) + " roommates:";
		var roommatesNames = " " + _getRoommateNames();
		if(_roomEditable) {
			return [
				d.a(roommatesLink).activate(function (event) {
					event.preventDefault();
					compass.GA.trackEvent('Modify Member', 'Select', 'Roommates');
					_popupModifyRoomModal('roommatesOption');
					return false;
				}), roommatesNames
			];
		} else {
			return roommatesLink + roommatesNames;
		}
	};

	var _getPaymentLinkText = function() {
		return _isCharging ? "Deposit:" : "Payment:";
	};

	var _drawUneditablePaymentLink = function() {
		return d.span({className: "paymentGuaranteeLink uneditablePayment"}, _getPaymentLinkText());
	};

	var _drawPaymentLink = function() {
		var paymentGuarantee;
		if(_roomEditable) {
			paymentGuarantee = d.a({className: "paymentGuaranteeLink", href: "#groupManage"}, _getPaymentLinkText()).activate(function (event) {
				event.preventDefault();
				compass.GA.trackEvent('Modify Member', 'Select', 'Payment');
				_popupModifyRoomModal('paymentOption');
				return false;
			});
		} else {
			paymentGuarantee = _drawUneditablePaymentLink();
		}
		return paymentGuarantee;
	};
	var _drawPayment = function() {
		var nameOnCard = _settings.assignedRoom.currentPayment.name_on_card + "'s ";
		var paymentName = _settings.assignedRoom.currentPayment.payMethodBase.name;
		var paymentCode = _settings.assignedRoom.currentPayment.payMethodBase.code;
		var editablePayments = _settings.hotelData.payMethods;
		var paymentLink;

		// unsupported arctic payments
		// check and wire transfer
		if(paymentCode === 'CHECK' || paymentCode === 'WIRE_TRANSFER') {
			paymentLink = [_drawUneditablePaymentLink(), " " + paymentName + " #" + _settings.assignedRoom.currentPayment.cc];

		// manual charge
		} else if(paymentCode === 'MANUAL_CHARGE') {
			paymentLink = [_drawUneditablePaymentLink(), " " + paymentName];

		// multiple payments 
		} else if(_settings.assignedRoom.payments.length > 1) {
			var allCreditCards = _.every(_settings.assignedRoom.payments, function(payment) { return payment.payMethodBase.is_credit_card; });
			paymentLink = [_drawUneditablePaymentLink(), allCreditCards ? _settings.labels.multipleCreditCards : _settings.labels.multiplePaymentMethods];

		// supported arctic payments
		// credit card
		} else if (_settings.assignedRoom.currentPayment.payMethodBase.is_credit_card === true) {
			paymentLink = [
				_drawPaymentLink(),
				" " + nameOnCard + _settings.assignedRoom.currentPayment.payMethodBase.name + " ending in " + _settings.assignedRoom.currentPayment.cc
			];
		// editable complex payment
		} else if(_.find(editablePayments, function(payment){
			return payment.code === _settings.assignedRoom.currentPayment.payMethodBase.code;
		})) {
			paymentLink = [_drawPaymentLink(), " " + paymentName];

		// special cases that should always be editable: company guarantee, payment required
		} else if(paymentCode === 'GUARANTEE' || paymentCode === 'PAYMENT_REQUIRED') { 
			paymentLink = [_drawPaymentLink(), " " + paymentName];

		// all others
		} else {
			paymentLink = [_drawUneditablePaymentLink(), " " + paymentName];
		}

		return paymentLink;
	};

	var _setNights = function(roomTypes, arrive, depart, avail) {
		return _.map(roomTypes, function(rt) {
			// because we are changing avail info, we need a deep copy of the roomtype
			var _rt = jQuery.extend(true, {}, rt);

			// getNightsBetween returns a new array with references to night objects. i.e. currentNights are references to _rt.nights
			var currentNights = compass.group.NamesHelper.getNightsBetween(arrive, depart, _rt.nights);
			_.each(currentNights, function(n) {
				if(_translate){
					n.availBase.availInfo = avail;
				}
				else{
					n.availInfo = avail;
				}
			});
			return _rt;
		});
	};

	var _updateAssignedRoomTypes = function(roomTypes, reservation) {
		// set nights in current reservation to show as available
		var updatedRoomTypes = _setNights(roomTypes, reservation.arrive, reservation.depart, 'AVAIL');
		return updatedRoomTypes;
	};

	var _updateUnassignedRoomTypes = function(roomTypes) {
		if(_settings.unassignedRoomsInfo.length === 0) {
			return roomTypes;
		}

		var unassignedRoomsByArrive = _.sortBy(_settings.unassignedRoomsInfo, function(room) { return room.arrive; });
		var unassignedRoomsByDepart = _.sortBy(_settings.unassignedRoomsInfo, function(room) { return room.depart; });
		
		var minArrive = _.first(unassignedRoomsByArrive).arrive;
		var maxDepart = _.last(unassignedRoomsByDepart).depart;
		var updatedRoomTypes = _setNights(roomTypes, minArrive, maxDepart, 'AVAIL');
		return updatedRoomTypes;
	};

	var _drawRoomTypeArriveDepart = function(container) {


		if(_settings.assignedRoom) {
			_roomTypeArriveDepartWidget = new compass.group.RoomTypeArriveDepartWidget(container, {
				meetingInfo: _settings.meetingInfo,
				editable: _settings.assignedRoom.reservationBase.datesEditable,
				onlyStayRanges: _settings.onlyStayRanges,
				availabilityInfoBasedOnCheckin : $j.extend(true, [], _settings.roomTypes),
				roomTypes: _updateAssignedRoomTypes(_settings.roomTypes, _settings.assignedRoom.reservationBase),
				selectedBlocked_room_id : _settings.assignedRoom.reservationBase.blocked_room_id,
				selectedArrive : _settings.assignedRoom.reservationBase.arrive,
				selectedDepart : _settings.assignedRoom.reservationBase.depart,
				unassignedRoomsInfo : _settings.unassignedRoomsInfo,
				onChange: _initializeChangeEvent,
				translate: _translate,
				processClickOnRoomTypes : false,
				selectOptionText: _settings.labels.check_in_and_out.label,
			});

			if(!_settings.onlyStayRanges) {
				// this replaces the dom.js default click handler
				_roomTypeArriveDepartWidget.find('.dataSelect.roomTypesSelect,.dataSelect.checkInSelect,.dataSelect.checkOutSelect').activate(function(evt,evtData){
					evt.preventDefault();
					evt.stopPropagation();
					var classname = evt.currentTarget.className;

					var	dataHandler = function(data){
						container.empty();
						/*need to update the data in the RoomManageWidget data here so we work with the latest and greatest */
						/* the data that we are setting here comes from /roomTypes and it is in the old format (already translated), so we need to */
						/* pass in _translate = false for every new instantiation of a RoomTypeArriveDepartWidget*/
						_settings.roomTypes = data.roomTypes;
						_translate = false;
						_roomTypeArriveDepartWidget = new compass.group.RoomTypeArriveDepartWidget(container, {
							meetingInfo: _settings.meetingInfo,
							editable: _roomEditable,
							onlyStayRanges: _settings.onlyStayRanges,
							availabilityInfoBasedOnCheckin : $j.extend(true, [], data.roomTypes),
							roomTypes: _updateAssignedRoomTypes(data.roomTypes, _settings.assignedRoom.reservationBase),
							selectedBlocked_room_id : _settings.assignedRoom.reservationBase.blocked_room_id,
							selectedArrive : _settings.assignedRoom.reservationBase.arrive,
							selectedDepart : _settings.assignedRoom.reservationBase.depart,
							unassignedRoomsInfo : _settings.unassignedRoomsInfo,
							onChange: _initializeChangeEvent,
							translate: _translate,
							selectOptionText: _settings.labels.check_in_and_out.label,
						});

						_roomTypeArriveDepartWidget.find( '.' + classname.split(' ').join('.') + ' .dataSelectInput').activate();
					};

					evtObj = {
						data: {
							hotel_id : _settings.hotelData.hotelBase.hotel_id,
							blocked_room_id: _settings.assignedRoom.reservationBase.blocked_room_id,
							group_id : _settings.groupInfo.groupBase.group_id,
							housing_id: _settings.assignedRoom.reservationBase.housing_id
						},
						dataHandler : dataHandler
					};

					me.trigger('RoomManageWidget.requestRoomTypes', evtObj);
				});
			}

		} else {
			var _roomTypes;
			if(_settings.onlyStayRanges) {
				_roomTypes = _.filter(_settings.roomTypes, function(rt) {
					var roomTypeInStayRange = _.find(_settings.unassignedRoomsInfo, function(unassignedRoom) {
						return unassignedRoom.blocked_room_id === rt.blocked_room_id;
					});
					return roomTypeInStayRange ? true : false;
				});
			} else {
				_roomTypes = _settings.roomTypes;
			}

			var defaultRoomType = _.find(_roomTypes, function(rt) {
				return rt.blocked_room_id === _settings.defaultBlocked_room_id;
			});
			var _defaultBlocked_room_id = defaultRoomType ? defaultRoomType.blocked_room_id : null;

			/*data from initial /groupManage needs to be translated, subsequent ajax calls like /assignRoom return the data in the old/already transalted format*/
			_roomTypeArriveDepartWidget = new compass.group.RoomTypeArriveDepartWidget(container, {
				meetingInfo: _settings.meetingInfo,
				editable: _roomEditable,
				onlyStayRanges: _settings.onlyStayRanges,
				availabilityInfoBasedOnCheckin : $j.extend(true, [], _roomTypes),
				roomTypes: _updateUnassignedRoomTypes(_roomTypes),
				selectedArrive : _settings.blockData.defaultArrive,
				selectedDepart : _settings.blockData.defaultDepart,
				mostCommonBlocked_room_id : _defaultBlocked_room_id,
				unassignedRoomsInfo : _settings.unassignedRoomsInfo,
				onChange: _initializeUnassignedRoomChangeEvent,
				translate: _translate,
				showPrice : false,
				selectedRoomType : false,
				processClickOnRoomTypes: _settings.onlyStayRanges ? true : false,
				selectOptionText: _settings.labels.check_in_and_out.label,
			});

			if(!_settings.onlyStayRanges) {
				// this replaces the dom.js default click handler and is controlled by processClickOnRoomTypes
				_roomTypeArriveDepartWidget.find('.dataSelect.roomTypesSelect,.dataSelect.checkInSelect,.dataSelect.checkOutSelect').activate(function(evt,evtData){
					evt.preventDefault();
					evt.stopPropagation();
					var classname = evt.currentTarget.className;

					var	dataHandler = function(data){
						container.empty();

						// permissioned roomTypes will not come back from ajax call so check that currently booked roomTypes are included in data
						_.each(_settings.unassignedRoomsInfo, function(unassignedRoom) {
							var unassignedRoomType = _.find(data.roomTypes, function(rt) {
								return rt.blockedRoomId === unassignedRoom.blocked_room_id;
							});
							if(!unassignedRoomType) {
								var missingUnassignedRoomType = _.find(_settings.roomTypes, function(rt) {
									return rt.blocked_room_id === unassignedRoom.blocked_room_id;
								});

								// format the missing roomType so it matches the data coming back from the ajax call
								// does the same thing as _translate = true for this one roomType
								missingUnassignedRoomType.avgNightlyRate = missingUnassignedRoomType.avgRate;
								missingUnassignedRoomType.name = missingUnassignedRoomType.roomTypeBase.name;
								missingUnassignedRoomType.occupants = missingUnassignedRoomType.roomTypeBase.occupancy;
								missingUnassignedRoomType.blockedRoomId = missingUnassignedRoomType.blocked_room_id;
								var translateNights = _.map(missingUnassignedRoomType.nights,function(night){
									night.availInfo = night.availBase.availInfo;
									night.date = night.nightBase.night;
									night.roomPrice = night.availBase.roomPrice;
									return night;
								});
								missingUnassignedRoomType.nights = translateNights;
								data.roomTypes.push(missingUnassignedRoomType);
							}
						});

						/*need to update the data in the RoomManageWidget data here so we work with the latest and greatest */
						/* the data that we are setting here comes from /roomTypes and it is in the old format (already translated), so we need to */
						/* pass in _translate = false for every new instantiation of a RoomTypeArriveDepartWidget*/
						_settings.roomTypes = data.roomTypes;
						/*we also make a copy of the unmerged room types (availabilityInfoBasedOnCheckin) */
						/*so that we can use it to merge general availability with reservations based on a given check in later*/
						_translate = false;
						_roomTypeArriveDepartWidget = new compass.group.RoomTypeArriveDepartWidget(container, {
							meetingInfo: _settings.meetingInfo,
							editable: _roomEditable,
							onlyStayRanges: _settings.onlyStayRanges,
							availabilityInfoBasedOnCheckin : $j.extend(true, [], _updateUnassignedRoomTypes(data.roomTypes)),
							roomTypes: _updateUnassignedRoomTypes(data.roomTypes),
							mostCommonBlocked_room_id : _defaultBlocked_room_id,
							selectedArrive : _settings.blockData.defaultArrive,
							selectedDepart : _settings.blockData.defaultDepart,
							unassignedRoomsInfo : _settings.unassignedRoomsInfo,
							selectedRoomType : false,
							translate: _translate,
							showPrice: false,
							selectOptionText: _settings.labels.check_in_and_out.label,
						});

						_roomTypeArriveDepartWidget.find( '.' + classname.split(' ').join('.') + ' .dataSelectInput').activate();
					};

					evtObj = {
						/*take the first unassigned blocked_room_id, it will return all room types in the block that the blocked_room_id belongs to*/
						data: {
							hotel_id : _settings.hotelData.hotelBase.hotel_id,
							group_id : _settings.groupInfo.groupBase.group_id,
							blocked_room_id: _settings.blockData.unassignedRoomsInfo[0].blocked_room_id,
							housing_id: 0
						},
						dataHandler : dataHandler
					};
				
					me.trigger('RoomManageWidget.requestRoomTypes', evtObj);
				});
			}
		}
	};

	var _drawDiscardChangesButton = function() {
		return d.input({className : 'discardChangesButton secondaryButton', type:'submit', value: 'Discard Changes', tabindex: 1}).activate(function() {
			var sendGroupMemberConfo = me.find('.sendGroupMemberConfo');
			var sendConfoTip = me.find('.sendConfoTip');
			var eventData = {
					hotel_id: _settings.hotelData.hotelBase.hotel_id,
					block_id: _settings.block_id,
					housing_id: _settings.assignedRoom.reservationBase.housing_id
				};

			sendGroupMemberConfo.removeClass('disabled');
			sendGroupMemberConfo.activate(_handleGroupMemberConfoButtonClick);
			sendConfoTip.show();
			me.find('.buttonContainer').slideUp('fast', function() {
				me.trigger('RoomManageWidget.discardChanges', eventData);
			});
		});
	};

	var showLoadingOverlay = function(form, display){
		display = display || 'saving changes';
		form.addClass('processing');
		me.find('.processingMessage').text(display);
		var opts = _.extend({ }, compass.loading.defaultOptions, {top: '5px', position: 'relative' });
		_spinner = new Spinner(opts);
		_spinner.spin(me.find('.spinnerContainer').get(0));
	};

	me.hideLoadingOverlay = function(form){
		form.removeClass('active');
		form.removeClass('processing');
		if(_spinner){
			_spinner.stop();
		}
	};	

	var _drawSaveChangesButton = function() {
		return d.input({className : 'button saveChangesButton saveButton', type: 'submit', value: 'Save Changes', tabindex: 1}).activate(function() {
			_respondToSaveChangesButtonClick(me.find('.assignedRoomForm'));
		});
	};

	var _initializeUnassignedRoomChangeEvent = function(){
		/*used by the view to keep track of which forms have been modified*/
		me.trigger('RoomManageWidget.initializeUnassignedRoomChange', _settings.block_id);
		_enableOrDisableFormSubmitButton(me.find('.unassignedRoomForm'), function(){_respondToAssignRoomButtonClick(unassignedRoomForm);});
	};

	var _initializeChangeEvent = function(event){
		isAssignedFormChanged = true;
		var assignedRoomForm = me.find('.assignedRoomForm');
		var sendGroupMemberConfo = me.find('.sendGroupMemberConfo');
		var sendConfoTip = me.find('.sendConfoTip');
		me.find('.buttonContainer').slideDown('fast');
		/*make this room widget appear above the overlay*/
		assignedRoomForm.addClass('active');
		sendGroupMemberConfo.off();
		sendGroupMemberConfo.addClass('disabled');
		sendConfoTip.hide();
		_enableOrDisableFormSubmitButton(assignedRoomForm, function(){_respondToSaveChangesButtonClick(assignedRoomForm);});
		me.trigger('RoomManageWidget.InitializeAssignedRoomChange');
	};

	var _makeFormTabbable = function(theForm){
		var obj = theForm ? $(theForm) : me;
		/* first tab through the form inputs*/
		obj.find(':input').attr('tabindex', 1);
		
		/* tab through the links */
		obj.find('a').attr('tabindex', 2);

		obj.find('.dataSelectInput').attr('tabindex', 1);
	};

	var _makeFormNotTabbable = function(theForm){
		var obj = theForm ? $(theForm) : me;
		/* make all the inputs NOT tabbable */
		obj.find(':input').attr('tabindex', -1);
		/* make all the links not tabbable */
		obj.find('a').attr('tabindex', -1);

		obj.find('.dataSelectInput').attr('tabindex', -1);
	};

	var _respondToKeyDown = function(event) {
		/* don't initialize a change event when the user is just tabbing through */
		if (event.keyCode != 9 && event.keyCode != 13) {
			_initializeChangeEvent();
		} else if (event.keyCode == 13 && isAssignedFormChanged) {
			event.preventDefault();
			event.stopPropagation();
			_respondToSaveChangesButtonClick(me.find('.assignedRoomForm'));
		}
	};

	var _drawAssignedRoomForm = function() {
		var hasFocus = false;
		var action = '';
		var room = _settings.assignedRoom;
		var assignedRoomFormContents;
		var cancelRoomButton = _drawCancelRoomButton();
		var sendGroupMemberConfoButton = _settings.canSendConfo ? _drawSendGroupMemberConfoButton().activate(_handleGroupMemberConfoButtonClick) : "";
		var assignedRoomFormClass = 'assignedRoomForm';
		var roomRequestClassname = room.reservationBase.housingComment.length > 0 || room.reservationBase.housingRequest != "" || room.reservationBase.programNumber != "" ? "roomRequests fa-solid fa-comment" : "roomRequests fa-regular fa-comment";

		if(_roomEditable) {
			assignedRoomFormContents = [
				d.input({className : "firstName nameField",
					name : "firstName",
					placeholder : _labels.first_name.placeholder,
					type : "text",
					"data-parsley-required": "true",
					"data-parsley-error-message": _labels.first_name.hint,
					'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
					value : room.individualBase.first_name,
					maxlength : 20,
					onkeydown: _respondToKeyDown
				}).change(function(){
					compass.GA.trackEvent('Update Unassigned', 'Modify', 'First Name');
					_initializeChangeEvent();
				}),
				d.input({className : "lastName nameField",
					name : "lastName",
					placeholder : _labels.last_name.placeholder,
					type : "text",
					"data-parsley-required": "true",
					"data-parsley-error-message": _labels.last_name.hint,
					'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
					value : room.individualBase.last_name,
					maxlength : 18,
					onkeydown: _respondToKeyDown
				}).change(function(){
					compass.GA.trackEvent('Update Unassigned', 'Modify', 'Last Name');
					_initializeChangeEvent();
				}),
				d.input({className : "email",
					name : "email",
					id: "email-input",
					placeholder : _labels.email.placeholder,
					"data-parsley-type" : "email",
					"data-parsley-required": "true",
					type: "email",
					"data-parsley-error-message": _labels.email.hint,
					value : room.individualBase.email,
					onkeydown: _respondToKeyDown
				}).change(function(){
					compass.GA.trackEvent('Update Unassigned', 'Modify', 'Email');
					_initializeChangeEvent();
				}),
				d.div({className : 'controls' },
					sendGroupMemberConfoButton,
					d.a({href: "#", className: roomRequestClassname}, d.span({ className: "requestsTip"}, "Room Requests")).activate(function (event) {
						event.preventDefault();
						compass.GA.trackEvent('Modify Member', 'Select', 'Requests');
						_popupModifyRoomModal('requestsOption');
						return false;
					}),
					cancelRoomButton
				),
				d.div({ className : 'roomTypeArriveDepartContainer'}),
				d.div({className: "roommatesContainer"}, d.div({className: "roommates"}, _drawRoommates())),
				d.div({className: "paymentGuaranteeContainer"}, d.div({className: "paymentGuarantee"}, _drawPayment())),
				d.div({className: 'buttonContainer'},
					_drawDiscardChangesButton(),
					_drawSaveChangesButton()
				),
				d.div({id: 'processingContainer'}, 
					d.div({className: 'messageAndSpinnerContainer'},
						d.div({className:'processingMessage'}),
						d.div({className : 'spinnerContainer'})
					)
				)
			];
		} else {
			assignedRoomFormClass += ' uneditable';
			assignedRoomFormContents = [
				d.div({ className : "firstName nameField" }, room.individualBase.first_name),
				d.div({ className : "lastName nameField" }, room.individualBase.last_name),
				d.div({ className : "email" }, room.individualBase.email),
				d.div({ className : 'roomTypeArriveDepartContainer'}),
				d.div({className: "roommatesContainer"}, d.div({className: "roommates"}, _drawRoommates())),
				d.div({className: "paymentGuaranteeContainer"}, d.div({className: "paymentGuarantee"}, _drawPayment()))
			];
		}

		assignedRoomForm = d.form({
			className : assignedRoomFormClass,
			method : 'POST',
			target : '_blank',
			action : action,
			novalidate: "novalidate"
		}, assignedRoomFormContents);

		_drawRoomTypeArriveDepart(assignedRoomForm.find('.roomTypeArriveDepartContainer'));

		assignedRoomForm.submit(function(evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_submitRoomForm(assignedRoomForm);
		});

		var onFormFocus = function(e) {
			e.stopPropagation();
			hasFocus = true;
			assignedRoomForm.addClass('hasFocus');
			_makeFormTabbable();
		};

		var onFormBlur = function(e) {
			e.stopPropagation();
			hasFocus = false;
			setTimeout(function() {
				if(!hasFocus) {
					assignedRoomForm.removeClass('hasFocus');
					_makeFormNotTabbable();
				}
			}, 500);
		};

		assignedRoomForm.focusin(onFormFocus);

		assignedRoomForm.focusout(onFormBlur);

		_parsleyCustomization(assignedRoomForm, function(){_respondToSaveChangesButtonClick(assignedRoomForm);});

		assignedRoomForm.bind("RoomTypeArriveDepartWidget.roomTypeChanged", function (event) {
			compass.GA.trackEvent('Update Assigned', 'Modify', 'Room Type');
		});

		assignedRoomForm.bind("RoomTypeArriveDepartWidget.assignedDateChange", function (event, eventData) {
			compass.GA.trackEvent('Update Assigned', 'Modify', eventData);
		});

		assignedRoomForm.submit(function(evt) {
			evt.preventDefault();
			evt.stopPropagation();
			_submitRoomForm(assignedRoomForm);
		});

		_makeFormNotTabbable(assignedRoomForm);

		return assignedRoomForm;
	};

	var _drawCancelRoomButton = function() {
		if (_settings.blockData.canCancel && _settings.assignedRoom.reservationBase.canCancel) {
			return d.a({href: "#", className: "cancelRoom fa-regular fa-trash-can"}, d.span({ className: "cancelRoomTip"}, "Cancel Room")).activate(function (event) {
				event.preventDefault();
				compass.GA.trackEvent('Modify Member', 'Select', 'Cancel');
				_popupModifyRoomModal('cancelOption');
				return false;
			});
		} else {
			return '';
		}
	};

	var _drawSendGroupMemberConfoButton = function() {
		return d.a({className: "sendGroupMemberConfo fa-regular fa-envelope"}, d.span({ className: "sendConfoTip"}, "Send Confirmation"));
	};

	var _handleGroupMemberConfoButtonClick = function(event) {
		event.preventDefault();
		showLoadingOverlay(me.find('.assignedRoomForm'), 'sending confirmation');

		function hideLoadingOverlay() {
			me.hideLoadingOverlay($('.assignedRoomForm'));
		}

		eventData = {attendanceId: _settings.assignedRoom.reservationBase.attendance_id, hideLoadingOverlay: hideLoadingOverlay};
		me.trigger('RoomManageWidget.SendGroupMemberConfo', eventData);
	};

	var _validateForm = function(form){
		form.parsley().validate();
		var datesValid = _roomTypeArriveDepartWidget.validateDates();
		if(!datesValid){
			_parsleyError = true;
		}
		// Only validate if the dataSelect for group member list is active
		if (useGroupMemberList && !groupMemberSelection.addMember) {
			var memberListValid = me.validateMemberDropdown();
			if (!memberListValid) {
				_parsleyError = true;
			}
		}
		/* typically validate functions return true for validated and false otherwise*/
		return !_parsleyError;
	};

	var _respondToAssignRoomButtonClick = function(form){
		var button = form.find(".saveButton");
		_disableButton(button);

		if(!_roomEditable || !_validateForm(form)){
			return;
		}

		var dateRestrictionErrorMessages = _checkForRestrictedDates();

		if (_parsleyError === false && !dateRestrictionErrorMessages.length) {
			var eventData = {
				hotel_id: _settings.hotelData.hotelBase.hotel_id,
				block_id: _settings.block_id,
				assignData : me.grabValues(),
				raceConditionFailure: raceConditionFailure
			};
			showLoadingOverlay(me.find('.unassignedRoomForm'), 'saving changes');

			// Need to remove group member from other lists, if applicable
			var blockManageWidgets = $(".groupManageView").find('.BlockManageWidget');
			blockManageWidgets.trigger('RoomManageWidget.removeGroupMemberFromList', groupMemberSelection.attendanceId );

			me.trigger('RoomManageWidget.AssignRoom', eventData);
		}
		else{
			var rdh = compass.util.restrictedDateHelper();
			rdh.displayMultiErrorAlert(dateRestrictionErrorMessages);
		}
	};

	var _checkForRestrictedDates = function(){
		var rdh = compass.util.restrictedDateHelper();
		var roomTypeAndDates = _roomTypeArriveDepartWidget.grabValues();
		var selectedRoomType = _.find(_settings.roomTypes, function(roomType) {
			return (roomType.blocked_room_id || roomType.blockedRoomId) === roomTypeAndDates.blocked_room_id;
		});
		var noArriveDatesArray = rdh.restrictedDates(selectedRoomType.nights, true);
		var noDepartDatesArray = rdh.restrictedDates(selectedRoomType.nights, false);
		var violatedRestrictedDates = rdh.violatedRestrictedDates(
			[{"arrive" : roomTypeAndDates.arrive, "depart" : roomTypeAndDates.depart}],
			noArriveDatesArray, 
			noDepartDatesArray
		);
		return dateRestrictionErrorMessages = rdh.createDateRestrictionErrors(violatedRestrictedDates);
	};

	var _respondToSaveChangesButtonClick = function(form){
		if(!_roomEditable || !_validateForm(form)){
			return;
		}

		var dateRestrictionErrorMessages = [];
		var rdh = compass.util.restrictedDateHelper();
		var roomTypeAndDates = _roomTypeArriveDepartWidget.grabValues();
		var selectedRoomType = _.find(_settings.roomTypes, function(roomType) {
			return (roomType.blocked_room_id || roomType.blockedRoomId) === roomTypeAndDates.blocked_room_id;
		});
		var noArriveDatesArray = rdh.restrictedDates(selectedRoomType.nights, true);
		var noDepartDatesArray = rdh.restrictedDates(selectedRoomType.nights, false);
		var violatedRestrictedDates = rdh.violatedRestrictedDates(
			[{"arrive" : roomTypeAndDates.arrive, "depart" : roomTypeAndDates.depart}],
			noArriveDatesArray, 
			noDepartDatesArray
		);
		var dateRestrictionErrorMessages = _checkForRestrictedDates();

		if (_parsleyError === false && !dateRestrictionErrorMessages.length) {
			isAssignedFormChanged = false;
			me.find('.buttonContainer').slideUp('fast');
			showLoadingOverlay(form, 'saving changes');

			var eventData = {
				hotel_id: _settings.hotelData.hotelBase.hotel_id,
				block_id: _settings.block_id,
				housing_id: _settings.assignedRoom.reservationBase.housing_id,
				previous_blocked_room_id: _settings.assignedRoom.reservationBase.blocked_room_id,
				assignData :  me.grabValues(),
				callback: function() {
					// _settings.submitCallback();
				}
			};
			me.trigger('RoomManageWidget.updateAssignedRoom', eventData);
		}
		else{
			rdh.displayMultiErrorAlert(dateRestrictionErrorMessages);
		}
	};

	var _drawUnassignedRoomForm = function() {
		if(_settings.unassignedRoomsInfo.length <= 0){
			return '';
		}

		var action = '';

		var unassignedRoomFormClass = 'unassignedRoomForm';
		if(_roomEditable === false) {
			unassignedRoomFormClass += ' uneditable';
		}
		
		var memberDataSelect = {};

		var assignButton = d.input({className : 'saveButton button', type: 'submit', value: 'Assign Room'}).activate(function() {
			_respondToAssignRoomButtonClick(unassignedRoomForm);
		});
		if(!_roomEditable) {
			_disableButton(assignButton);
		}
		
		// Creates the email input element when called
		var createUnassignedEmailInput = function() {
			return d.input({className : "unassignedEmail",
				id: "email-input",
				name : "email",
				type : "email",
				placeholder : _labels.email.placeholder,
				value : _settings.groupInfo.groupBase.emailBase.email,
				disabled : _roomEditable === false,
				"data-parsley-type" : "email",
				"data-parsley-required": "true",
				"data-parsley-error-message" : _labels.email.hint
			}).change(function() {
				_initializeUnassignedRoomChangeEvent();
				compass.GA.trackEvent('Update Assigned', 'Modify', 'Email');
			});
		};


		// For creating the Group Member Name Dropdown element
		var createMemberDataSelect = function() {

			// Whenever this data select is newly created, we must ensure the associated variables are reset
			groupMemberSelection = {};

			// If there are no more named members to be assigned, return regular inputs instead and disable the group member select
			if (groupMemberList.length <= 1) {
				useGroupMemberList = false;
				return createMemberNameInputs();
			}

			// function for replacing dropdown with name inputs when 'Add New Member' has been selected
			var replaceWithNameInputs = function() {

				var nameInputs = createMemberNameInputs();
				var firstName = nameInputs[0];
				var lastName  = nameInputs[1];

				// This button will remove itself and the inputs declared above and replace with the member dropdown again
				var undoButton;
				var replaceNameInputsWithDropdown = function(){
					firstName.remove();
					lastName.remove();
					undoButton.remove();
					me.find('.memberSelectNewName').replaceWith( createMemberDataSelect() );
				};

				undoButton = d.div(
					{className: "removeNameInputs fa-regular fa-circle-xmark"}
				).click( replaceNameInputsWithDropdown );

				var holderDiv = d.div({
					className: "memberSelectNewName"
				}, firstName, lastName, undoButton);
				
				me.find('.memberListSelect').replaceWith( holderDiv );
			};

			// function for drawing the chosen member name in the dataSelect
			var drawMemberName = function(member) {
				var displayValue = _settings.labels.member_list.placeholder;
				if (member) {
					// There is a special element with property 'addMember', indicating
					// that we should trigger the addMember functionality
					if (member.addMember) {
						displayValue = d.div({className: 'addNewMemberName'}, 
							d.span({className: "fa-regular fa-plus", style: {display: 'table-cell', 'padding-right':'.3em'}}),
							d.div( {className: 'newMemberName', style: {display: 'table-cell'}}, "Add new member")
						);
					} else {
						displayValue = d.div({className: 'memberName'}, (member.FIRST_NAME+' '+member.LAST_NAME));
					}
				}
				return displayValue;
			};

			// function for drawing the name selections in the dataSelect dropdown
			var drawMemberLabel = function(data) {
				var displayValue = _settings.labels.member_list.placeholder;
				if (data) {
					displayValue = data.FIRST_NAME+' '+data.LAST_NAME;
				}
				return displayValue;
			};

			// Create and return the dataselect element
			var memberSelect = d.dataSelect({
				data : groupMemberList,
				initialSelection : -1,
				className : 'memberListSelect',
				labelMapper : drawMemberLabel,
				choiceMapper : drawMemberName,
				disabledClassName : 'unavailableRow',
				idGenerator : compass.generateId,
				change : function(data) {
					
					var emailElement = me.find('.unassignedEmail')[0];
					
					if (data.addMember) {
						// If addMember is present and True, we need to replace this dropdown with a firstName & lastName field
						groupMemberSelection = { addMember: true };
						$(emailElement).removeAttr('readonly');
						replaceWithNameInputs();
						return;
					} else {
						// groupMemberSelection is used when Assign Button is clicked so that the correct information is passed through
						groupMemberSelection = {
							firstName: data.FIRST_NAME,
							lastName: data.LAST_NAME,
							attendanceId: data.ATTENDANCE_ID
						};
					}
					
					if (data.EMAIL) {
						emailElement.value = data.EMAIL;
						$(emailElement).attr('readonly','');
					}

					me.validateMemberDropdown();
					_initializeUnassignedRoomChangeEvent();
				},
				defaultBlank: false
			});
			
			return memberSelect;
		};
		
		// For creating the regular FirstName LastName inputs
		var createMemberNameInputs = function() {

			var firstName = d.input({className : "unassignedFirstName",
				name : "firstName",
				type : "text",
				placeholder : _labels.first_name.placeholder,
				disabled : _roomEditable === false,
				maxlength : 20,
				"data-parsley-required": "true",
				'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
				"data-parsley-error-message": _labels.first_name.hint
			}).change(function() {
				_initializeUnassignedRoomChangeEvent();
				compass.GA.trackEvent('Update Assigned', 'Modify', 'First Name');
			});

			var lastName = d.input({className : "unassignedLastName",
				name : "lastName",
				type : "text",
				placeholder : _labels.last_name.placeholder,
				disabled : _roomEditable === false,
				maxlength : 18,
				"data-parsley-required": "true",
				'data-parsley-pattern': /[^\d\s\.]/,  //Contains at least 1 alpha
				"data-parsley-error-message": _labels.last_name.hint
			}).change(function(){
				_initializeUnassignedRoomChangeEvent();
				compass.GA.trackEvent('Update Assigned', 'Modify', 'Last Name');
			});

			return [ firstName, lastName ];
		};

		// This variable is used to decide whether to render a name dropdown or empty name inputs on the Unassigned Room Form
		var inputName = function() {
			var nameElements = (useGroupMemberList === true) ? [ createMemberDataSelect() ]  :  createMemberNameInputs();
			nameElements.push(  createUnassignedEmailInput() );

			return nameElements;
		};

		unassignedRoomForm = d.form({className : unassignedRoomFormClass, 
			id: 'unassignedForm_' + _settings.block_id, method : 'POST', target : '_blank', action : action, novalidate: "novalidate"},
			inputName,
			d.div({ className : 'roomTypeArriveDepartContainer'}),
			assignButton
		);
		_drawRoomTypeArriveDepart(unassignedRoomForm.find('.roomTypeArriveDepartContainer'));

		if(!_settings.blockData.defaultArrive.length){
			/*we only want to put 'select date' when we don't have default arrive/depart dates*/
			//unassignedRoomForm.find('.EditReservationDatesWidget .dataSelectInputLabel').html(_labels.check_in_and_out.label);
		}

		var processingOverlay = d.div({id: 'processingContainer'}, 
			d.div({className: "messageAndSpinnerContainer"},
				d.div({className:'processingMessage'}),
				d.div({className : 'spinnerContainer'})
			)
		);
		unassignedRoomForm.append(processingOverlay);

		_parsleyCustomization(unassignedRoomForm, function(){_respondToAssignRoomButtonClick(unassignedRoomForm);});

		unassignedRoomForm.bind("RoomTypeArriveDepartWidget.roomTypeChanged", function (event) {
			compass.GA.trackEvent('Update Unassigned', 'Modify', 'Room Type');
		});

		unassignedRoomForm.bind("RoomTypeArriveDepartWidget.unassignedDateChange", function (event, eventData) {
			_enableOrDisableFormSubmitButton(me.find('.unassignedRoomForm'), function(){_respondToAssignRoomButtonClick(unassignedRoomForm);});
			compass.GA.trackEvent('Update Unassigned', 'Modify', eventData);
		});

		// We need this function to be able to update all member dropdowns in the groupManage view when any one of the names gets assigned
		me.bind("BlockManageWidget.replaceGroupMemberList", function (event, newList) {
			var button = unassignedRoomForm.find(".saveButton");

			// this is to prevent the currently-submitted list from updating and risking the submitted data being replaced
			if ( useGroupMemberList && !button.hasClass('disabled')) { 
				groupMemberList = [{addMember: true}].concat( newList );
				
				// Its possible to have useGroupMemberList be true but not have the dropdown present if 'add new member' has been selected.
				// Because of this, we only want to attempt replacement if the dropdown is currently active
				if ( me.find('.memberListSelect').length > 0) {

					var newGroupMemberSelectElement = createMemberDataSelect();
					var newEmailInput = createUnassignedEmailInput();
					me.find('.memberListSelect').replaceWith( newGroupMemberSelectElement );
					me.find('.unassignedEmail').replaceWith( newEmailInput );

				} else if (groupMemberList.length <= 1) {
					// Specifically need to handle the case where 'add new member' has been selected but there is no longer group member list
					// to return to upon pressing X. In that case, just replace the specialized 'add new member' name inputs with the regular ones
					me.find(".memberSelectNewName").replaceWith( createMemberNameInputs() );
				}
			}
		});

		unassignedRoomForm.submit(function(evt) {
			evt.preventDefault();
			evt.stopPropagation();
		});

		return unassignedRoomForm;
	};


	var _submitRoomForm = function(form) {
		var button = form.find(".saveButton");

		if (button.hasClass('disabled')) {
			return;
		}
		
		button.addClass('disabled');
		form.parsley().validate();

		if (!form.parsley().isValid()) {
			_parsleyError = true;
			return;
		}
	};

	var _enableButton = function(button, clickHandler){
		// Only enable the button if the button is disabled, otherwise you get multiple activate handlers triggered by the same click
		if (button.hasClass('disabled')) {
			button.removeClass('disabled');
			/*multiple click handlers were creating odd side effects on the names page, we should only have one click handler at a time*/
			button.deactivate();
			button.activate(clickHandler);
		}
	};

	var _disableButton = function(button){
		button.addClass('disabled');
		button.deactivate();
	};

	/*buttonClickCallback is needed because we are actually deactivating and reactivating events when we disable/enable the button*/
	/*we need to know what callback fires when we re-activate the button */
	var _enableOrDisableFormSubmitButton = function(form, buttonClickCallback) {
		var button = form.find(".saveButton");
		if (form.find('.invalid').length < 1) {
			_parsleyError = false;
			_enableButton(button, buttonClickCallback);
		}
		else{
			_parsleyError = true;
			_disableButton(button);
		}
	};

	var _getNumberOfRoommates = function() {
		var roommates = _settings.assignedRoom.roommates;
		var numberOfRoommates = roommates.length;
		return numberOfRoommates;
	};

	var _getRoommateNames = function() {
		var roommatesData = _settings.assignedRoom.roommates;
		var roommates = [];

		_.each(roommatesData, function(roommate) {
			roommates.push(" " + roommate.individualBase.first_name + " " + roommate.individualBase.last_name);
		});
		return roommates;
	};

	var _popupModifyRoomModal = function(tab) {
		var eventData = {
			tab: tab,
			hotelData: _settings.hotelData,
			assignedRoom: _settings.assignedRoom,
			groupInfo: _settings.groupInfo,
			block_id: _settings.block_id,
			modifyRoomId: _modifyRoomId,
			blockData: _settings.blockData,
		};
		me.trigger('RoomManageWidget.showModifyRoomModal', eventData);
	};

	var _updatePayment = function(paymentData) {
		_settings.assignedRoom.currentPayment.payment_id = paymentData.payment.paymentId;
		_settings.assignedRoom.currentPayment.name_on_card = paymentData.individualInfo.firstName + ' ' + paymentData.individualInfo.lastName;
		_settings.assignedRoom.currentPayment.cc = paymentData.payment.lastFour;
		_settings.assignedRoom.currentPayment.exp = '2015-07-15';
		me.find('.roomForm .paymentGuarantee').empty().append(_drawPayment());
	};
	me.updatePayment = _updatePayment;

	var _updateUnassignedRooms = function(updatedUnassignedRoomsInfo) {
		_settings.unassignedRoomsInfo = updatedUnassignedRoomsInfo;
		if(!_settings.unassignedRoomsInfo.length){
			return;/*we might be in this widget when unassignedRoomsInfo has no information when the last unassigned room has been assigned for example*/
		}

		if(!_settings.assignedRoom) {
			var rtArriveDepartContainer = unassignedRoomForm.find('.roomTypeArriveDepartContainer');
			rtArriveDepartContainer.empty();
			_drawRoomTypeArriveDepart(rtArriveDepartContainer);
		}
	};
	me.updateUnassignedRooms = _updateUnassignedRooms;
	
	me.success = function() {
		//_editReservationDatesWidget.disableDropDown();
	};

	var failure = function() {
		d.alert("There was an error. Your reservation did not save. Please try again.");
		_finishLoading();
		me.hideLoadingOverlay($('.unassignedRoomForm'));
	};

	var raceConditionFailure = function() {
		compass.trackEvent('RaceConditionAlert');
		_soldOutAlert = d.alert({
							message: "The selected dates are unavailable.",
							onClose: function() {
								window.location.reload();
							}
						});
		me.hideLoadingOverlay($('.unassignedRoomForm'));
	};

	var _parsleyCustomization = function(form, submitCallback) {
		form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function(elem) {
				var positionErrorBubble = function(inputField, bubble){
					var TEXT_WIDTH_PLUS_PADDING = 155;
					var bubbleWidth = bubble.outerWidth(true);
					if(bubble.text() === ''){
						/*hack to get around the fact that at this time, parsley has not inserted the error message */
						/* into the bubble, making its width about 10px which should be around 155px when the text is there. This will only be the case the first time we create the bubble*/
						bubbleWidth = TEXT_WIDTH_PLUS_PADDING;
					}
					bubble.css({ "left": (inputField.outerWidth(true)-bubbleWidth)/2 + inputField.position().left });
				};

				elem = elem.$element;
				var existingErrorBubble = elem.next();

				if (existingErrorBubble.hasClass('reqHint')) {
					return existingErrorBubble;
				}

				var newErrorBubble = d.div({ className: 'reqHint' });
				newErrorBubble.append(d.div({ className: 'triangle' }));

				elem.after(newErrorBubble);

				elem.click('focus', function (evt) {
					positionErrorBubble(elem, newErrorBubble);
				});
				elem.focus(function(evt){
					positionErrorBubble(elem, newErrorBubble);
				});
				positionErrorBubble(elem, newErrorBubble);
				return newErrorBubble;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorElem: '<span></span>'
		});

		form.parsley().on('field:validate', function(elem) {
			return !$(elem).is(":visible") || $(elem).hasClass('placeholder');		
		});

		form.parsley().on('form:error', function() {
			_parsleyError = true;
		});
	};

	var makeDropDownInvalid = function(dataSelect, errorMessage){
		return d.errorBubble({
			elem : dataSelect,
			errorMessage : errorMessage
		});
	};
	
	var makeDropDownValid = function(dataSelect){
		dataSelect.removeClass('invalid');
		dataSelect.find('.reqHint').remove();
	};

	me.validateMemberDropdown = function(){
		var memberListSelect = me.find('.memberListSelect');
		if(_.isEmpty(groupMemberSelection)){
			makeDropDownInvalid(memberListSelect, _settings.labels.member_list.hint );
			return false;
		}
		makeDropDownValid(memberListSelect);
		return true;
	};

	me.grabValues = function() {
		var roomTypeAndDates = _roomTypeArriveDepartWidget.grabValues();
		var firstName, lastName, attendanceID;
		if ( useGroupMemberList && !groupMemberSelection.addMember ) { 
			// If a member select list is present, use active selection from that element
			attendanceID = groupMemberSelection.attendanceId;
			firstName = groupMemberSelection.firstName;
			lastName = groupMemberSelection.lastName;
		} else {
			// Otherwise, search for input fields and grab those values
			firstName = me.find("input[name='firstName']").val();
			lastName = me.find("input[name='lastName']").val();
		}
		return {
			first_name: firstName,
			last_name: lastName,
			email: me.find("input[name='email']").val(),
			blocked_room_id : roomTypeAndDates.blocked_room_id,
			arrive : roomTypeAndDates.arrive,
			depart : roomTypeAndDates.depart,
			attendance_id : attendanceID
		};
	};

	me.render = function(widgetElem) {
		widgetElem.attr('id', uniqueId);
		var housingId = _settings.assignedRoom ? _settings.assignedRoom.reservationBase.housing_id : '';
		widgetElem.append(_drawRoomForms());

		me.find("#email-input").emailautocomplete({
			suggClass: "eac-sugg",
			domains: ["aol.com", "att.net", "bellsouth.net", "comcast.com", "comcast.net", "gmail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "qq.com", "sbcglobal.net", "yahoo.com", "ymail.com"]
		});

		me.remove = function() {
			widgetElem.remove();
		};
	};
}, {
	WUID: 'DEFAULT',
	widgetName: 'RoomManageWidget',
	roomTypes: {},
	assignedRoom: undefined,
	unassignedRoomsInfo: [],
	hotelData: {},
	block_id: '',
	meetingInfo: {},
	requestsInfo: {},
	cancelInfo: {},
	groupInfo: {},
	countriesAndStates: {},
	blockEditable: true,
	defaultBlocked_room_id : null,
	onlyStayRanges: false,
	canCancel: true,
	memberList: [],
	labels: {
		first_name: {
			label: 'First Name:',
			placeholder: 'First Name',
			hint: 'A valid first name is required'
		},
		last_name: {
			label:  'Last Name:',
			placeholder: 'Last Name',
			hint: 'A valid last name is required'
		},
		email: {
			label: 'Email Address:',
			placeholder: 'Email',
			hint: 'A valid email address is required'
		},
		check_in_and_out: {
			label: 'Select date'
		},
		member_list: {
			label: 'Group Member List',
			placeholder: 'Select guest to assign to room',
			hint: 'Name is required'
		},
		multipleCreditCards: ' Multiple Credit Cards',
		multiplePaymentMethods: ' Multiple Methods'
	}
});
